import LineItemFormTab from '@/Enums/CampaignManagement/LineItemFormTab.enum';

export const LINE_ITEM_TABS = Object.values(LineItemFormTab);
export const DEFAULT_ACTIVE_TAB = LineItemFormTab.Basic;
